import useSWR from 'swr';

export const GET_USER_MEDIA_API = '/usermedialibrary/get_list_with_folders';
const fetcher = (url: string) => fetch(url).then((res) => res.json());

export interface UserMediaInfo {
  id: string;
  invalid: string;
  media_id: string;
  modified_date: string;
  upload_date: string;
  user_id: string;
}

export interface UserFolderInfo {
  id: string;
  invalid: string;
  name: string;
  created_at: string;
  user_id: string;
  medias: string;
}

interface useUserMediaProps {
  onError?: () => void;
}

interface useUserMediaFolderProps {
  folders: UserFolderInfo[];
  images: UserMediaInfo[];
}

export const useUserMedia = ({
  onError,
}: useUserMediaProps): { data: useUserMediaFolderProps | undefined; error: Error } => {
  const onErrorCallback = onError ? onError : () => null;
  const { data, error } = useSWR(GET_USER_MEDIA_API, fetcher, { onError: onErrorCallback });

  return { data, error };
};
